import { render } from "./TableOfContent.vue?vue&type=template&id=755036ca&scoped=true&ts=true"
import script from "./TableOfContent.vue?vue&type=script&lang=ts"
export * from "./TableOfContent.vue?vue&type=script&lang=ts"

import "./TableOfContent.vue?vue&type=style&index=0&id=755036ca&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755036ca"]])

export default __exports__